import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useI18n } from '../../context/I18nContext';
import AnimatedEyebrow from '../AnimatedEyebrow';

export default function SparePartsSupportSection() {
  const { t } = useI18n();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section className="relative">
      <div className="relative pt-[80px] pb-[60px]">
        <div className="container relative z-10 mx-auto px-6 md:px-6 lg:px-12">
          <div className="relative rounded-3xl bg-[var(--dash-main)]">
            <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-3xl">
              <div className="absolute inset-0 opacity-50 bg-[url('/bg/1.webp')] bg-no-repeat bg-[size:100%_100%]" />
            </div>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-100px' }}
              className="relative flex flex-col gap-6 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8 md:p-10 lg:p-12"
            >
              <div className="min-w-0 max-w-2xl">
                <AnimatedEyebrow className="mb-6">{t('sparePartsPage.support.eyebrow')}</AnimatedEyebrow>
                <motion.h2
                  variants={itemVariants}
                  className="break-words text-3xl font-black uppercase leading-[0.95] tracking-[-0.01em] text-white sm:text-4xl md:text-5xl"
                >
                  <span className="block text-white font-[500]">{t('sparePartsPage.support.title')}</span>
                </motion.h2>

                <motion.p variants={itemVariants} className="mt-2 text-md text-white/85 sm:text-base">
                  {t('sparePartsPage.support.description')}
                </motion.p>
              </div>

              <motion.div variants={itemVariants}>
                <Link
                  href="/contact"
                  className="group/cta relative inline-flex items-center gap-3 overflow-hidden rounded-full bg-white px-8 py-4 text-sm font-bold text-[var(--dash-main)] transition-all active:scale-95 hover:pr-14 hover:bg-[var(--dash-blacker)] hover:text-white"
                >
                  <span className="relative z-10">{t('sparePartsPage.support.requestAssistance')}</span>
                  <ArrowRight className="absolute right-5 h-5 w-5 translate-x-8 opacity-0 transition-all group-hover/cta:translate-x-0 group-hover/cta:opacity-100" />
                </Link>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
